var _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24618 12.6527L14.4131 19.6901C14.754 20.0792 15.3318 20.1054 15.7038 19.7488C16.0757 19.3922 16.1008 18.7877 15.7599 18.3986L10.1528 12L15.7599 5.60136C16.1008 5.21231 16.0757 4.60781 15.7038 4.25119C15.3318 3.89456 14.754 3.92084 14.4131 4.30989L8.24616 11.3474C8.18045 11.4207 8.12777 11.5026 8.08828 11.5896C7.97118 11.8475 7.96997 12.1503 8.08828 12.4104C8.12777 12.4974 8.18046 12.5793 8.24618 12.6527Z",
    fill: "#347DB0"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 4,
    width: 8,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24618 12.6527L14.4131 19.6901C14.754 20.0792 15.3318 20.1054 15.7038 19.7488C16.0757 19.3922 16.1008 18.7877 15.7599 18.3986L10.1528 12L15.7599 5.60136C16.1008 5.21231 16.0757 4.60781 15.7038 4.25119C15.3318 3.89456 14.754 3.92084 14.4131 4.30989L8.24616 11.3474C8.18045 11.4207 8.12777 11.5026 8.08828 11.5896C7.97118 11.8475 7.96997 12.1503 8.08828 12.4104C8.12777 12.4974 8.18046 12.5793 8.24618 12.6527Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#347DB0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.d2101b3e75fa6f2a1ed1f3d89e9ae015.svg";
export { ForwardRef as ReactComponent };